module.exports = __webpack_public_path__ + "img/pro_01transfer.eb41dfa1.png";